<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

<jni-order-notes-sidebar
  #ordernotessidebar
  [(display)]="displaySidebar"
  [saleOrderId]="saleOrderId"
  (refreshOrderNotesGrid)="getSalesOrderNotes()"
  (closeSidebar)="closeSideBarForOrderNotes()"
  [proposalIdD365EditFieldValidation]="proposalIdD365EditFieldValidation"
  [orderType]="orderType"></jni-order-notes-sidebar>

<div class="col-lg-12 parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pb-2 mb-3 globalborder-btm-header p-3 pt-1 res-tab-custom">
        <span class="col-auto d-flex gap-3 align-items-center head-custom-span">
          <h2 class="mb-0">
            Order# <b>{{ saleOrderId }}</b>
          </h2>

          <div class="d-flex gap-3 inside-custom-span">
            <div
              class="ordersummary-total client-badge d-flex align-items-center">
              Status:<b
                class=""
                *ngIf="invoiceProposalExists?.toLowerCase() !== 'yes'"
                >{{ salesOrderStatusD365 }}</b
              >
              <b
                class="i-perview-color"
                *ngIf="invoiceProposalExists?.toLowerCase() === 'yes'"
                >I-Preview</b
              >
            </div>
            <div
              class="ordersummary-total client-badge d-flex align-items-center">
              Subtotal:<b>{{
                subTotal | currency: foreignCurrency : "symbol" : "0.2-2"
              }}</b>
            </div>
            <div
              class="ordersummary-status client-badge d-flex align-items-center">
              Net:<b>{{ net | currency: "USD" }}</b>
            </div>
            <div
              class="ordersummary-status client-badge d-flex align-items-center">
              Net GP:<b>{{ netGp | currency: "USD" }}</b>
            </div>
            <div
              class="ordersummary-status client-badge d-flex align-items-center">
              Net GP%:<b class="wordwrap">
                <b *ngIf="getInfinity(netGpPercentage)">
                  {{ netGpPercentage | number: "1.2-2" }}
                </b>
                <a *ngIf="netGpPercentage && getInfinity(netGpPercentage)">{{
                  percentageSign
                }}</a>
              </b>
            </div>
            <div
              class="ordersummary-status client-badge me-auto d-flex align-items-center">
              <div *ngIf="showCommissionsFields">
                Net est. comm:
                <b>{{ commission | currency: "USD" }}</b>
              </div>
            </div>
          </div>
        </span>

        <span class="col-auto d-flex gap-2 tab-custom right-custom-span">
          <a class="mt-1 me-2" (click)="refreshOrderSummaryPage()">
            <i class="pi pi-sync" pTooltip="Refresh" tooltipPosition="top"></i>
          </a>
          <a class="mt-1">
            <i
              class="pi pi-truck user-select-auto"
              (click)="redirectToFreightEstimationPage()"></i>
            <!-- <img
            style="cursor: pointer"
            (click)="redirectToFreightEstimationPage()"
            src="../../../../../assets/images/freight-car.png" /> -->
          </a>
          <div
            class="ordersummary-panel gap-3 ml-auto d-flex justify-content-between">
            <div class="nav-link p-0 d-flex align-items-center wordwrap">
              <a
                class="link d-flex align-items-center gap-1"
                (click)="redirectToFreightChargesPage()">
                <!-- <a class="link d-flex align-items-center gap-1">
                  <i class="pi pi-truck"></i
                ></a> -->
                <a class="freight-size">Freight Chg:</a>
                {{ freightChargeAmount | currency }}</a
              >
            </div>
            <div
              class="nav-link p-0 d-flex align-items-center gap-1"
              *ngIf="openPrinfPdfFlag">
              <a><i class="pi pi-clone"></i></a>
              <a class="link" (click)="openPrinfPdfModal()">PO's</a>
            </div>
            <!-- <div
        class="ms-3 nav-link p-0 d-flex align-items-center"
        *ngIf="poExistFlag"
      >
        <i class="icon-Email me-2"></i>
        <a class="link" (click)="sendEmailPO()">Email PO</a>
      </div> -->
            <div class="nav-link p-0 d-flex align-items-center gap-1">
              <a><i class="pi pi-clone"></i></a>
              <!-- <a class="link" (click)="copyHeader()">Copy</a> -->
              <a class="link" (click)="modalOrderProposal()">Copy Order</a>
            </div>
            <div
              class="nav-link p-0 d-flex align-items-center gap-1"
              *ngIf="userBlockedFromEdit && isEditButtonVisible">
              <a><i class="pi pi-pencil"></i></a>
              <a class="link" (click)="onSaleOrderEdit()">Edit</a>
            </div>
            <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center">
                  <i class="icon-Add me-2"></i>
                  <a class="link" routerLink="/orders/order-header">New</a>
                </div> -->
            <div class="p-menu-icon">
              <p-menu #menu [model]="items" [popup]="true"></p-menu>
              <p-button
                (click)="menu.toggle($event)"
                icon="pi pi-ellipsis-v"
                [link]="true" />
            </div>
            <!-- <div
              ngbDropdown
              class="d-flex align-items-center justify-content-center">
              <a ngbDropdownToggle>
                <i class="pi pi-ellipsis-v"></i>
              </a>
              <ul ngbDropdownMenu class="dropdown-menu py-3 mt-1">
                <li>
                  <a class="dropdown-item" (click)="printProjectConfirmation()"
                    >Print Project Confirmation</a
                  >
                </li>
                <li>
                  <a class="dropdown-item" (click)="printProjectApproval()"
                    >Print Project Approval</a
                  >
                </li> -->
            <!-- <li>
            <a class="dropdown-item" (click)="printProjectConfirmation('false')"
              >Print Project Confirmation Force</a
            >
          </li>
          <li>
            <a class="dropdown-item" (click)="printProjectApproval('false')"
              >Print Project Approval Force</a
            >
          </li> -->
            <!-- <li *ngIf="poExistFlag">
            <a class="dropdown-item" (click)="printAllPOs()">Print All POs</a>
          </li> -->

            <!-- <li>
                  <a class="dropdown-item" (click)="printOrderSummary()"
                    >Print Order Summary
                  </a>
                </li>

                <li
                  *ngIf="
                    salesOrderLine.length > 0 &&
                    salesOrderStatusD365 !== 'Invoiced'
                  ">
                  <a
                    class="dropdown-item"
                    (click)="openProFormaInvoice('proFormaInvoice')"
                    >Pro Forma Invoice
                  </a>
                </li>

                <li
                  *ngIf="
                    salesOrderLine.length > 0 &&
                    salesOrderStatusD365 !== 'Invoiced'
                  ">
                  <a
                    class="dropdown-item"
                    (click)="openProFormaInvoice('depositInvoice')"
                    >Deposit Invoice
                  </a>
                </li>
              </ul>
            </div> -->

            <div *ngIf="isModal">
              <i class="pi pi-times" (click)="closeOrderSummaryModal()"></i>
            </div>
          </div>
        </span>
      </span>
      <div class="pb-2">
        <div class="adduser-container-hgt px-3">
          <div class="col-lg-12">
            <form [formGroup]="saleOrderForm">
              <div class="col-12">
                <div class="gray-bg-rounded" formGroupName="orderHeader">
                  <div class="row">
                    <div
                      class="form-group has-float-label col"
                      (click)="onNewClientRedirect()">
                      <label class="form-label"
                        >Client account<span class="madatory-field"
                          >*</span
                        ></label
                      >
                      <input
                        pInputText
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control has-link disable-color icon-blue"
                        formControlName="customerId"
                        (keydown)="onKeyDown($event)" />
                    </div>

                    <div class="col">
                      <div
                        class="form-group has-float-label ptable-small"
                        #buyerInputDiv>
                        <label class="form-label">Buyer</label>
                        <input
                          pInputText
                          pInputText
                          jniAutoCompleteBlocker
                          type="text"
                          id="buyer"
                          name="buyer"
                          class="form-control"
                          [value]="buyerName"
                          (input)="buyerVendor$.next($any($event.target).value)"
                          (keyup)="
                            onBuyerSearchOpenToggle(summaryBuyerPop, $event)
                          "
                          (keydown.Tab)="getBuyer($event, summaryBuyerPop)"
                          (blur)="logValidationErrors()"
                          (click)="
                            onContactList(
                              $event,
                              summaryBuyerPop,
                              buyerInputDiv
                            )
                          "
                          formControlName="buyer" />
                      </div>
                      <p-popover
                        class="order-dropdown add"
                        #summaryBuyerPop
                        aria-labelledby="dropdownBasic1">
                        <div class="indropdowntable">
                          <p-table
                            #dt
                            stripedRows
                            [rowHover]="true"
                            [showCurrentPageReport]="true"
                            [size]="'small'"
                            [scrollable]="true"
                            [value]="buyerLists"
                            styleClass="p-datatable-customers order-listing"
                            [rowHover]="true"
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            [paginator]="false"
                            [filterDelay]="0"
                            styleClass="table-listing">
                            <ng-template pTemplate="header">
                              <tr class="table-head">
                                <th class="name">Buyer</th>
                                <th class="client" pSortableColumn="client">
                                  Client
                                  <p-sortIcon field="Client"></p-sortIcon>
                                </th>
                                <th class="vaccount">Account</th>
                                <th class="street">Street</th>
                                <th class="city">City</th>
                                <th class="state">State</th>
                                <th class="lastOrderDate">Last order date</th>
                              </tr>
                              <tr>
                                <th>
                                  <div class="d-flex">
                                    <input
                                      pInputText
                                      jniAutoCompleteBlocker
                                      type="text"
                                      name="buyer"
                                      id="buyerFilter"
                                      style="max-width: 200px"
                                      (input)="
                                        dt.filter(
                                          $any($event.target).value,
                                          'buyer',
                                          'contains'
                                        )
                                      "
                                      placeholder=""
                                      class="p-column-filter p-inputtext p-component" />
                                  </div>
                                </th>
                                <th>
                                  <div class="d-flex">
                                    <input
                                      pInputText
                                      jniAutoCompleteBlocker
                                      type="text"
                                      name="organizationNameD365"
                                      id="organizationNameD365"
                                      style="max-width: 200px"
                                      (input)="
                                        dt.filter(
                                          $any($event.target).value,
                                          'organizationNameD365',
                                          'contains'
                                        )
                                      "
                                      placeholder=""
                                      class="p-column-filter p-inputtext p-component" />
                                  </div>
                                </th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                              </tr>
                            </ng-template>
                            <ng-template
                              pTemplate="body"
                              let-buyerList
                              let-rowIndex="rowIndex">
                              <tr
                                class="p-selectable-row mousepointer"
                                (click)="
                                  onBuyerSelection(buyerList, summaryBuyerPop)
                                ">
                                <td class="buyer mousepointer">
                                  {{ buyerList.buyer }}
                                </td>
                                <td class="client mousepointer">
                                  {{ buyerList.organizationNameD365 }}
                                </td>
                                <td class="vaccount mousepointer">
                                  {{ buyerList.account }}
                                </td>
                                <td
                                  style="width: 200px"
                                  class="sname mousepointer">
                                  {{ buyerList.street }}
                                </td>
                                <td class="city mousepointer">
                                  {{ buyerList.city }}
                                </td>
                                <td
                                  style="width: 72px"
                                  class="state mousepointer">
                                  {{ buyerList.state }}
                                </td>
                                <td
                                  style="width: 75px"
                                  class="country mousepointer">
                                  {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
                                </td>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="20">No buyer found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </p-popover>
                    </div>
                    <div
                      *ngIf="editHeaderStatus"
                      class="d-flex justify-content-start pb-0 mt-4 pt-1 col add-btn"
                      (click)="addContactInformationBuyer()">
                      <a
                        *ngIf="
                          customerBillToObject?.clientAccount &&
                          editHeaderStatus
                        "
                        class="link-gray addNewClient nav-link link-gray"
                        ><i class="icon-Add"></i>+ Add</a
                      >
                    </div>
                    <div class="col">
                      <div class="form-group has-float-label">
                        <label class="form-label"
                          >Job name<span class="madatory-field">*</span></label
                        >
                        <input
                          pInputText
                          jniAutoCompleteBlocker
                          type="text"
                          class="form-control"
                          formControlName="jobName"
                          [ngClass]="{ 'has-error': formErrors['jobName'] }"
                          (blur)="logValidationErrors()" />

                        <span class="error-msg" *ngIf="formErrors['jobName']">
                          {{ formErrors["jobName"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col">
                      <jni-program
                        #programs
                        [isSalesOrder]="true"
                        [parent]="saleOrderForm"
                        (disableBuyer)="disableBuyerFeild()"
                        (programEvent)="getProgramDetails($event)"
                        (smallLoaderEvent)="getPDFLoaderStatus($event)"
                        [programName]="programName"
                        [customerAccount]="customerAccountNumber">
                      </jni-program>
                    </div>
                    <div class="col">
                      <div class="form-group has-float-label">
                        <label class="form-label">ship Date</label>
                        <p-datepicker
                          jniAutoCompleteBlocker
                          inputId="basic"
                          class="date-input"
                          formControlName="shipDate"
                          (onSelect)="onShipDateSelection($event)"
                          [minDate]="shipDateCurrentdate"
                          [ngClass]="{ 'has-error': formErrors['shipDate'] }"
                          (onBlur)="logValidationErrors()"
                          [showOtherMonths]="true"
                          [selectOtherMonths]="true"></p-datepicker>

                        <span class="error-msg" *ngIf="formErrors['shipDate']">
                          {{ formErrors["shipDate"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group has-float-label">
                        <label class="form-label"
                          >In-hands date<span class="madatory-field"
                            >*</span
                          ></label
                        >
                        <p-date-picker
                          jniAutoCompleteBlocker
                          inputId="basic"
                          class="date-input"
                          formControlName="inHandsDate"
                          [defaultDate]="sharedMonthForView"
                          (onSelect)="onInHandDateSelection($event)"
                          [minDate]="inHandDateCurrentdate"
                          [ngClass]="{ 'has-error': formErrors['inHandsDate'] }"
                          (onBlur)="logValidationErrors()"
                          [showOtherMonths]="true"
                          [selectOtherMonths]="true"></p-date-picker>

                        <span
                          class="error-msg"
                          *ngIf="formErrors['inHandsDate']">
                          {{ formErrors["inHandsDate"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group has-float-label">
                        <label class="form-label"
                          >Method of Payment<span class="madatory-field"
                            >*</span
                          ></label
                        >
                        <p-select
                          id="currency"
                          formControlName="methodOfPaymentHeader"
                          (onChange)="getCreditCard($event)"
                          [ngClass]="{
                            'has-error': formErrors['methodOfPaymentHeader'],
                          }"
                          (blur)="logValidationErrors()"
                          [options]="customerPaymentMethodList"
                          optionLabel="Name"
                          optionValue="Name">
                        </p-select>

                        <span
                          class="error-msg"
                          *ngIf="formErrors['methodOfPaymentHeader']">
                          {{ formErrors["methodOfPaymentHeader"] }}
                        </span>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group has-float-label" #bcDivElement>
                        <label class="form-label"
                          >Branding Consultant<span class="madatory-field"
                            >*</span
                          ></label
                        >
                        <input
                          pInputText
                          pInputText
                          jniAutoCompleteBlocker
                          jniAutoCompleteBlocker
                          type="text"
                          id="brandingConsultant"
                          name="brandingConsultant"
                          class="form-control"
                          formControlName="brandingConsultant"
                          (click)="
                            onBrandingConsultantSelection(
                              $event,
                              brandingConsultantPop,
                              bcDivElement
                            )
                          "
                          [ngClass]="{
                            'has-error': formErrors['brandingConsultant'],
                          }"
                          (blur)="logValidationErrors()" />

                        <span
                          class="error-msg"
                          *ngIf="formErrors['brandingConsultant']">
                          {{ formErrors["brandingConsultant"] }}
                        </span>
                      </div>
                      <p-popover
                        #brandingConsultantPop
                        aria-labelledby="dropdownBasic4"
                        class="order-dropdown">
                        <p-table
                          #dt
                          [value]="brandingConsultantLists"
                          styleClass="p-datatable-customers order-listing"
                          [rowHover]="true"
                          [rows]="10"
                          [showCurrentPageReport]="true"
                          [rowsPerPageOptions]="[10, 25, 50]"
                          [paginator]="false"
                          [filterDelay]="0">
                          <ng-template pTemplate="header">
                            <tr>
                              <th class="name">Project id</th>
                              <th class="vaccount">Project name</th>
                            </tr>
                          </ng-template>
                          <ng-template
                            pTemplate="body"
                            let-brandingConsultantList
                            let-rowIndex="rowIndex">
                            <tr
                              class="p-selectable-row mousepointer"
                              (click)="
                                onProjectIdSelection(
                                  brandingConsultantList,
                                  brandingConsultantPop
                                )
                              ">
                              <td class="name mousepointer">
                                {{ brandingConsultantList.projectId }}
                              </td>
                              <td class="name mousepointer">
                                {{ brandingConsultantList.projectName }}
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="20">No project found.</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </p-popover>
                    </div>
                    <div class="col">
                      <div class="form-group has-float-label">
                        <label class="form-label"
                          >Accounts coordinator<span class="madatory-field"
                            >*</span
                          ></label
                        >
                        <p-select
                          [(ngModel)]="bacUserDefaultSelectionId"
                          formControlName="accountsCoordinator"
                          [ngClass]="{
                            'has-error': formErrors['accountsCoordinator'],
                          }"
                          (onBlur)="logValidationErrors()"
                          [options]="bacList"
                          optionLabel="name"
                          optionValue="personnelNumber">
                          <ng-template let-com pTemplate="item">
                            {{ com.personnelNumber }} : {{ com.name }}
                          </ng-template>
                          <ng-template pTemplate="selectedItem" let-com>
                            {{ com?.personnelNumber }} : {{ com?.name }}
                          </ng-template>
                        </p-select>

                        <span
                          class="error-msg"
                          *ngIf="formErrors['accountsCoordinator']">
                          {{ formErrors["accountsCoordinator"] }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="collapse-section mt-1 mb-1 d-flex justify-content-end">
                <a class="btn-collapse" (click)="onHeaderToggle()"
                  >{{ collapseHeaderHeading }} <i class="icon-angle-double"></i
                ></a>
              </div>
              <div class="col-12">
                <div class="row collapseable" [hidden]="collapseHeaderStatus">
                  <div class="col-3">
                    <div class="gray-bg-rounded">
                      <div
                        class="fixingflexcol"
                        formGroupName="customerAddress">
                        <h3 class="mb-2">Bill To</h3>
                        <div
                          class="form-group has-float-label mb-2"
                          (click)="onNewClientRedirect()">
                          <label class="form-label">Name</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control has-link disable-color icon-blue"
                            formControlName="name"
                            (keydown)="onKeyDown($event)" />
                        </div>
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Attention</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="billingAttentionD365" />
                        </div>
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Location</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="billingLocationD365" />
                        </div>
                        <div
                          class="form-group has-float-label mb-2"
                          (click)="onNewClientRedirect()">
                          <label class="form-label">Address</label>
                          <textarea
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            rows="5"
                            class="form-control has-link disable-color icon-blue"
                            formControlName="address"
                            (keydown)="onKeyDown($event)"></textarea>
                        </div>
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Phone number</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="telephone" />
                        </div>
                        <!-- <div class="form-group has-float-label mb-4">
          <div class="d-flex text-wrap-cs">
            <div class="me-3">
              Create
              {{ createdDate | date: 'MM-dd-yyyy' }}
              {{ createdDateName }}
            </div>
            <div>
              Mod
              {{ lastModifiedDate | date: 'MM-dd-yyyy' }}
              {{ lastModifiedName }}
            </div>
          </div>
        </div> -->
                      </div>
                    </div>

                    <div class="form-group has-float-label margintop-auto mt-3">
                      <a class="d-block">
                        Create
                        {{ createdDate | date: "MM-dd-yyyy" }}
                        {{ createdDateName }}
                      </a>
                      <a class="d-block">
                        Mod
                        {{ lastModifiedDate | date: "MM-dd-yyyy" }}
                        {{ lastModifiedName }}
                      </a>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="gray-bg-rounded">
                      <div formGroupName="shipTo">
                        <jni-ship-to-address
                          #shipTo
                          [parent]="saleOrderForm"
                          [deliveryAddress]="deliveryAddress"
                          [countryRegionList]="countryRegionList"
                          [customerBillToObject]="customerBillToObject"
                          (smallLoaderEvent)="getLoaderStatus($event)"
                          [editHeaderStatus]="editHeaderStatus"
                          [showAddress]="showAddress"
                          [formgroupName]="'shipTo'"
                          [formErrors]="formErrors"
                          (validationErrorEvent)="logValidationErrors()"
                          (melissaValidationIgnoreEvent)="
                            isMelissaValidationIgnoreEvent($event)
                          "
                          [isShipToAddressFromOrder]="true">
                        </jni-ship-to-address>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="gray-bg-rounded">
                      <div formGroupName="orderDetails">
                        <!-- <div class="form-group has-float-label mb-4">
          <input pInputText 
            jniAutoCompleteBlocker
            type="text"
            class="form-control"
            formControlName="buyer"
          />
          <label class="form-label">Buyer</label>
        </div> -->

                        <header
                          class="d-flex align-items-end justify-content-between">
                          <h3 class="m-0 mb-2">Details</h3>
                          <!-- <div
          <div
            class="d-flex justify-content-start pb-1"
            (click)="addContactInformation()"
          >
            <a
              *ngIf="editHeaderStatus && !proposalIdD365EditFieldValidation"
              class="addNewClient nav-link link-gray"
              ><i class="icon-Add"></i> Add new</a
            >
          </div> -->
                        </header>
                        <!-- <div class="col mb-4">
          <div ngbDropdown #contactdropdown="ngbDropdown">
            <div class="form-group has-float-label">
              <input pInputText 
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                formControlName="buyer"
                (focusout)="applyBuyerLengthValidation($event)"
                (click)="onContactList(contactdropdown)"
              />
              <label class="form-label">Buyer</label>
            </div>
            <div
              class="order-dropdown add"
              ngbDropdownMenu
              aria-labelledby="dropdownBasic1"
            >
              <div class="indropdowntable">
                <p-table
                  #dt
                  [value]="ClientAddresses"
                  styleClass="p-datatable-customers order-listing"
                  [rowHover]="true"
                  [rows]="10"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50]"
                  [paginator]="false"
                  [filterDelay]="0"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="name">Name</th>
                      <th class="vaccount">Phone</th>
                      <th class="street">Email</th>
                      <th class="city">Purpose</th>
                    </tr>
                  </ng-template>
                  <ng-template
                    pTemplate="body"
                    let-ClientAddresses
                    let-rowIndex="rowIndex"
                  >
                    <tr
                      class="p-selectable-row mousepointer"
                      (click)="
                        onCustomerSelection(
                          ClientAddresses.name,
                          contactdropdown
                        )
                      "
                    >
                      <td class="name mousepointer">
                        {{ ClientAddresses.name }}
                      </td>
                      <td class="vaccount mousepointer">
                        {{ ClientAddresses.phone }}
                      </td>
                      <td style="width: 100px" class="sname mousepointer">
                        {{ ClientAddresses.email }}
                      </td>
                      <td class="city mousepointer">
                        {{ ClientAddresses.purpose }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="20">No contact found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div> -->

                        <div class="form-group has-float-label mb-2">
                          <label class="form-label"
                            >Client PO number#
                            <span *ngIf="isCustomerPoRequiredField">*</span>
                          </label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            formControlName="customerPONumber"
                            [ngClass]="{
                              'has-error': formErrors['customerPONumber'],
                            }"
                            (blur)="logValidationErrors()" />

                          <span
                            class="error-msg"
                            *ngIf="formErrors['customerPONumber']">
                            {{ formErrors["customerPONumber"] }}
                          </span>
                        </div>
                        <div class="row">
                          <div>
                            <div class="form-group has-float-label mb-2">
                              <label class="form-label">Shipping Method</label>
                              <p-select
                                id="currency"
                                pInputText
                                formControlName="shippingMethod"
                                (onChange)="onShippingMethodChange($event)"
                                [options]="shippingProductsList"
                                optionLabel="modeDescriptionD365"
                                optionValue="modeCodeD365">
                              </p-select>
                            </div>
                          </div>
                          <div>
                            <div class="form-group has-float-label mb-2">
                              <label class="form-label">Sell Currency</label>
                              <input
                                pInputText
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                formControlName="foreignCurrency" />
                            </div>
                          </div>
                        </div>

                        <!-- <div class="row">
          <div class="col-6">
            <div class="form-group has-float-label mb-4">
              <input pInputText 
                disabled
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="createdDate | date: 'MM-dd-yyyy'"
              />
              <label class="form-label">Created Date</label>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group has-float-label mb-4">
              <input pInputText 
                disabled
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                [value]="lastModifiedDate | date: 'MM-dd-yyyy'"
              />
              <label class="form-label">Last Modified Date</label>
            </div>
          </div>
        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="gray-bg-rounded">
                      <div formGroupName="estimatedOrderTotals">
                        <h3 class="mb-2">Estimated Order Totals</h3>

                        <div class="col mb-4">
                          <div class="form-group has-float-label">
                            <label class="form-label">Estimated Tax:</label>
                            <input
                              pInputText
                              jniAutoCompleteBlocker
                              type="text"
                              class="form-control"
                              [value]="estimatedTax | currency: foreignCurrency"
                              (focusout)="calculateEstimatedTax($event)"
                              [disabled]="estimatedTaxStatus" />
                          </div>
                        </div>
                        <div class="col mb-2">
                          <div class="form-group has-float-label">
                            <label class="form-label">Estimated Freight:</label>
                            <input
                              pInputText
                              jniAutoCompleteBlocker
                              type="text"
                              class="form-control"
                              [value]="
                                estimatedFreight | currency: foreignCurrency
                              "
                              (focusout)="calculateEstimatedFreight($event)"
                              [disabled]="estimatedFreightStatus" />
                          </div>
                        </div>

                        <div class="mb-2">
                          <div class="form-group has-float-label mb-2">
                            <label class="form-label">Recommended Tax</label>
                            <input
                              pInputText
                              jniAutoCompleteBlocker
                              type="text"
                              class="form-control"
                              [value]="
                                recommendedTax | currency: foreignCurrency
                              "
                              disabled />
                          </div>
                        </div>
                        <div class="mb-2">
                          <p-button
                            label="Calculate tax"
                            type="button"
                            (click)="calculateRecommendedTax()" />
                        </div>

                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Order Total:</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            [value]="orderTotal | currency: foreignCurrency"
                            [disabled]="true" />
                        </div>
                        <div
                          class="d-flex align-items-center justify-content-between pb-2">
                          <h3 class="mt-1 mb-1">
                            Invoice Emails
                            <a
                              class="icon-Edit ms-3"
                              (click)="editInvoiceEmail()">
                              <i class="pi pi-pencil"></i>
                            </a>
                          </h3>
                        </div>
                        <div class="mb-4">
                          <p-table
                            #dt
                            stripedRows
                            [value]="invoiceEmail"
                            [(selection)]="selectedInvoiceEmail"
                            styleClass="p-datatable-customers ordersLineItems no-wrap table-hover-bg w-100"
                            [rowHover]="true"
                            [rows]="10"
                            [showCurrentPageReport]="true"
                            [rowsPerPageOptions]="[10, 25, 50]"
                            [paginator]="false"
                            [filterDelay]="0"
                            styleClass="table-listing">
                            <ng-template pTemplate="header">
                              <tr>
                                <th class="number">Name</th>
                                <th class="number">Purpose</th>
                                <th class="number">Email</th>
                                <th class="number">Invoice</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-invoiceEmail>
                              <ng-container>
                                <tr>
                                  <td>
                                    {{ invoiceEmail.name }}
                                  </td>
                                  <td>
                                    {{ invoiceEmail.purpose }}
                                  </td>
                                  <td>
                                    {{ invoiceEmail.email }}
                                  </td>
                                  <td class="input-check">
                                    <input
                                      disabled
                                      class="form-check-input me-2"
                                      type="checkbox"
                                      [checked]="invoiceEmail.invoice" />
                                  </td>
                                </tr>
                              </ng-container>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                              <tr>
                                <td colspan="20">No line item found.</td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                        <div
                          class="form-group has-float-label margintop-auto"
                          *ngIf="displayIROrderStatusReview">
                          <div>
                            <div>
                              IR status changed by:
                              <b>
                                {{
                                  getIRBillingReviewStatusResposne.lastModifiedBy ||
                                    getIRBillingReviewStatusResposne.createdBy
                                }}
                              </b>
                            </div>
                            <div>
                              IR status changed on:
                              <b>
                                {{
                                  getIRBillingReviewStatusResposne.lastModifiedDate ||
                                    getIRBillingReviewStatusResposne.createdDate
                                    | date: "MM-dd-yyyy"
                                }}
                              </b>
                            </div>
                            <div>
                              IR status:
                              <b>
                                {{
                                  getIRBillingReviewStatusResposne.isReadyForBillingReview ===
                                  true
                                    ? "Billing Review Accepted"
                                    : "Billing Review Rejected"
                                }}
                              </b>
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf="
                            salesOrderStatusD365?.toLowerCase() === 'open order'
                          ">
                          <div *ngIf="workflowAssigned">
                            <div class="mb-4">
                              <h2>Shipment Lifecycle</h2>
                            </div>
                            <div
                              class="form-group has-float-label mb-4"
                              (click)="openWorkflowModal()">
                              <label class="form-label">Assigned Project</label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                [ngModelOptions]="{ standalone: true }"
                                type="text"
                                class="form-control has-link disable-color"
                                [(ngModel)]="paddedProjectWorkflowId"
                                (keydown)="onKeyDown($event)" />
                            </div>
                          </div>
                          <div class="row" *ngIf="!workflowAssigned">
                            <div class="col">
                              <div class="mb-2">
                                <h2>Shipment Lifecycle</h2>
                              </div>
                              <div class="d-flex mb-2 gap-2">
                                <p-button
                                  label="Create New"
                                  type="button"
                                  (click)="confirmProjectCreate()" />

                                <p-button
                                  label=" Assign to Project"
                                  (click)="getPreSalesProjectList()" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf="
                            salesOrderStatusD365?.toLowerCase() ===
                              'invoiced' ||
                            salesOrderStatusD365?.toLowerCase() === 'delivered'
                          ">
                          <div *ngIf="workflowAssigned">
                            <div class="mb-4">
                              <h2>Shipment Lifecycle</h2>
                            </div>
                            <div
                              class="form-group has-float-label mb-4"
                              (click)="openWorkflowModal()">
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                [ngModelOptions]="{ standalone: true }"
                                type="text"
                                class="form-control has-link disable-color"
                                [(ngModel)]="paddedProjectWorkflowId"
                                (keydown)="onKeyDown($event)" />
                              <label class="form-label">Assigned Project</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div class="d-flex has-sticky justify-content-end saveBtn">
              <p-button
                *ngIf="editHeaderStatus"
                type="submit"
                [disabled]="!saleOrderForm.valid || updateButtonValidation"
                (onClick)="onHeaderUpdate()"
                [label]="'Save'">
              </p-button>
            </div>
          </div>

          <div
            class="gray-bg-rounded align-items-center justify-content-between col-12 mt-3 mb-3">
            <div
              class="align-items-center justify-content-between d-flex col-12">
              <div class="d-flex">
                <h2 class="m-0">Notes</h2>
                <div class="align-items-center justify-content-between d-flex">
                  <div
                    class="ordersummary-panel ml-auto d-flex justify-content-between"
                    *ngIf="userBlockedFromEdit">
                    <div class="ms-3 nav-link p-0 d-flex align-items-center">
                      <a class="link" (click)="openSideBarForOrderNotes()"
                        ><i class="pi pi-plus"></i> New</a
                      >
                    </div>
                  </div>
                  <div
                    class="ordersummary-panel ml-auto d-flex justify-content-between"
                    *ngIf="userBlockedFromEdit">
                    <div class="ms-3 nav-link p-0 d-flex align-items-center">
                      <a class="link" (click)="updateSideBarForOrderNotes()">
                        <i class="pi pi-pencil"></i> Edit</a
                      >
                    </div>
                  </div>
                  <div
                    class="ordersummary-panel ml-auto d-flex justify-content-between"
                    *ngIf="userBlockedFromEdit">
                    <div
                      class="ms-3 nav-link p-0 d-flex align-items-center"
                      *ngIf="salesOrderStatusD365 !== 'Invoiced'">
                      <a
                        class="link delcol"
                        (click)="deleteSideBarForOrderNotes()"
                        ><i class="pi pi-trash"></i> Delete</a
                      >
                    </div>
                  </div>
                  <div
                    class="ordersummary-panel ml-auto d-flex justify-content-between">
                    <div class="ms-3 nav-link p-0 d-flex align-items-center">
                      <a class="link" (click)="showAllOrderNotesOrNot()">{{
                        showAllOrderNotes ? "Show Less" : "Show All"
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <a
                  *ngIf="
                    salesOrderHeaderData?.salesOrderHeader?.copiedFromHeaderId
                  "
                  class="ordersummary-panel ml-auto d-flex text-right align-items-center">
                  Copied from
                  <a
                    style="line-height: normal"
                    (click)="redirectToCopiedFrom()"
                    class="link bold mx-3"
                    >{{ setCopiedFromInfo() }}</a
                  >
                  {{
                    salesOrderHeaderData.salesOrderHeader?.createdDate
                      | date: "MM-dd-yyyy"
                  }}
                </a>

                <a
                  class="btn-collapse d-flex justify-content-end align-items-center ms-2"
                  (click)="onNotesToggle()"
                  [ngClass]="{ active: collapseNotesStatus }"
                  >{{ collapseNotesHeading }} <i class="icon-angle-double"></i
                ></a>
              </div>
            </div>

            <div class="col-12">
              <div
                *ngIf="collapseNotesStatus"
                class="row collapseable zeroHeight"
                [ngClass]="{ active: collapseNotesStatus }">
                <jni-order-notes-grid
                  #ordernotes
                  [saleOrderId]="saleOrderId"
                  [userBlockedFromEdit]="userBlockedFromEdit"
                  [orderType]="orderType"
                  (selectedOrderNotesListing)="updateLineOnSideBar($event)"
                  [showAll]="showAllOrderNotes">
                </jni-order-notes-grid>
              </div>
            </div>
          </div>

          <jni-order-summary-line-items
            [salesOrderLine]="salesOrderLine"
            [OrderLineId]="saleOrderId"
            [currencyConversion]="currencyConversion"
            [foreignCurrency]="foreignCurrency"
            [releasedProductsList]="releasedProductsList"
            [salesOrderLines]="salesOrderLine"
            [purchaseOrderIdList]="purchaseOrderIdList"
            [smallLoader]="smallLoader"
            [salesOrderStatusD365]="salesOrderStatusD365"
            [approvalStatusD365]="approvalStatusD365"
            [isSaleOrderLineConfirmStatus]="isSaleOrderLineConfirmStatus"
            [avaiableCredit]="avaiableCredit"
            [subtotalForCreditLimitCheck]="subtotalForCreditLimitCheck"
            [getAvailableCreditBtnStatus]="getAvailableCreditBtnStatus"
            [saleOrderModalStatus]="saleOrderModalStatus"
            [userBlockedFromEdit]="userBlockedFromEdit"
            (changeDetect)="refreshPage($event)"
            (gridRefresh)="refreshPage(true)"
            (getPoListEvent)="callgetPurchaseOrderId($event)"
            (loadReleasedProductsEvent)="loadReleasedProducts()"
            (scrollHiddenStatus)="addScollHiddenClass()"
            (lineGridRefresh)="refreshSalesOrderLines()"
            [proposalIdD365EditFieldValidation]="
              proposalIdD365EditFieldValidation
            "
            [isFromOrderSummary]="true"
            [isLineEditDisabled]="isLineEditDisabled"
            [hideButtonsOnPageLoad]="hideButtonsOnPageLoad"
            (isAnyUnCommitLines)="isAnyUnCommitLinesEvent($event)"
            [isPartiallyInvoicedOrderLines]="isPartiallyInvoicedOrderLines"
            [isFromOrderSummary]="true"
            [orderType]="orderType"
            [releasedProductsVariantsList]="releasedProductsVariantsList"
            [customerFinancialDimension]="customerFinancialDimension"
            [serviceFeeFromD365]="serviceFeeFromD365"
            [workflowAssigned]="workflowAssigned"
            [shippingProductsList]="shippingProductsList"
            [saleOrderData]="saleOrderData"
            (selectedLineItemsEvent)="updateSelectedLineItems($event)">
          </jni-order-summary-line-items>

          <div class="gray-bg-rounded ordersummary-header mt-3">
            <div class="d-flex justify-content-between mb-2">
              <h2 class="m-0 wordwrap sec-title">Order Tracking</h2>

              <div
                class="justify-content-center d-flex"
                *ngIf="salesOrderStatusD365 !== 'Invoiced'">
                <div class="ms-3 nav-link d-flex align-items-center">
                  <a class="link" (click)="addIpTrackingLine()">+ Add</a>
                </div>
                <div class="ms-3 nav-link d-flex align-items-center">
                  <a class="link" (click)="uploadIpTrackingLine()"
                    ><i class="pi pi-cloud-upload icon-blue mx-1"></i> Upload</a
                  >
                </div>
                <div class="ms-3 nav-link d-flex align-items-center">
                  <a class="link delcol" (click)="deleteIpTrackingLine()"
                    ><i class="pi pi-trash"></i> Delete</a
                  >
                </div>
              </div>

              <div
                class="ordersummary-panel ml-auto d-flex justify-content-between">
                <div class="ms-3 nav-link p-0 d-flex align-items-center">
                  <a
                    class="link"
                    (click)="sellAllOrderTracking()"
                    *ngIf="showSeeAllButtonTracking"
                    ><b style="font-size: 1.2rem"
                      >More Sell Lines Exist (See All)</b
                    ></a
                  >
                </div>

                <div
                  class="collapse-section border-0 marginleft-auto d-flex justify-content-end">
                  <a
                    *ngIf="orderTrackingGridListing.length > 0"
                    class="link"
                    (click)="exportExcelForOrderTrackingData()"
                    >Export excel
                    <i class="icon-Export-excel me-2"></i>
                  </a>
                  <a class="btn-collapse mx-2" (click)="onOrderTrackingToggle()"
                    >{{ collapseOrderTrackingHeading }}
                    <i class="icon-angle-double"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="">
              <div class="cstm-collaspse">
                <div
                  [hidden]="!collapseOrderTrackingStatus"
                  class="row collapseable zeroHeight">
                  <jni-order-tracking
                    #orderTracking
                    [orderTrackingGridListing]="orderTrackingGridListing"
                    [calculateTotalForAllLines]="true"
                    [salesId]="saleOrderId"
                    [projId]="projId"
                    [defaultTracking]="defaultTracking"
                    (scrollHiddenStatus)="addScollHiddenClass()"
                    (refreshMainGrid)="
                      getOrderTrackingDataAgainstSaleOrder(saleOrderId, projId)
                    "
                    (showSeeAllButtonEvent)="showSeeAllButtonEvent($event)"
                    (getOrderNotesEvent)="getSalesOrderNotes()"
                    [salesOrderStatusD365]="salesOrderStatusD365"
                    [shippingProductsList]="shippingProductsList">
                  </jni-order-tracking>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-copy-header
  #copyheader
  [displayModal]="displayModal"
  (closeDialogEvent)="closeModalDialog()"
  [saleOrderId]="saleOrderId"
  (refreshGridEvent)="refreshGrid()"
  (saleOrderRedirect)="saleOrderRedirect($event)">
</jni-copy-header>

<p-dialog
  [closable]="false"
  [(visible)]="displayEmailInvoiceModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [position]="'center'"
  [autoZIndex]="true"
  appendTo="body">
  <jni-summary-invoice-emails
    #invoiceemail
    [displayEmailInvoiceModal]="displayEmailInvoiceModal"
    [parent]="saleOrderForm"
    [invoiceListing]="invoiceEmails"
    *ngIf="saleOrderForm.value"
    (newLine)="addNewLine($event)"
    (removeEmail)="removeEmail($event)"
    [addAndRemoveButtons]="addAndRemoveButtons"
    (closeInvoiceEmailModel)="closeInvoiceEmailModel()"
    (saveInvoiceEmailModel)="saveInvoiceEmailModel($event)"
    (removeInvoiceEmailModel)="removeInvoiceEmailModel($event)">
  </jni-summary-invoice-emails>
</p-dialog>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [isModal]="true"
      [clientIdFromModal]="customerId"
      (closeModalOnRedirectionEvent)="closeModalOnRedirection($event)"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeEvent)="closeModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-print-purchase-order
  [saleOrderId]="saleOrderId"
  [printPdfModal]="printPdfModal"
  [purchaseOrderLine]="purchaseOrderLine"
  (openPdfScreenModalEvent)="openPdfScreen($event)"
  (closePrintPdfModalEvent)="closePrinfPdfModal()">
</jni-print-purchase-order>

<jni-modal-stacker
  *ngIf="freightChargesDisplayModal"
  [displayModal]="freightChargesDisplayModal"
  (closeEvent)="closeModalForFreight()">
  <h1 class="panelHeading">Freight Charges</h1>
  <div class="panelBody">
    <jni-freight-charges
      [isModal]="true"
      [saleOrderId]="saleOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeTrackingListModalEvent)="closeModalForFreight()">
    </jni-freight-charges>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="poEmailDisplayModal"
  [displayModal]="poEmailDisplayModal"
  (closeEvent)="closeModalForPoEmail()">
  <h1 class="panelHeading mt-5"></h1>
  <div class="panelBody">
    <jni-po-email
      [poEmailData]="poEmailData"
      [isAnyUnCommitLines]="isAnyUnCommitLines"
      (refreshOrderLinesGrid)="refreshOrderLinesGridEvent()"
      (closePOEmailModalEvent)="closeModalForPoEmail()"
      [isModal]="true"></jni-po-email>
  </div>
</jni-modal-stacker>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [isFromOrdersAddNewBuyer]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="customerAccountNumber"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderTrackingModalStatus"
  [displayModal]="orderTrackingModalStatus"
  (closeEvent)="closeModalForOrderTracking()">
  <h1 class="panelHeading">Order Tracking Listing</h1>
  <div class="panelBody">
    <jni-order-tracking
      [salesId]="saleOrderId"
      [projId]="projId"
      [fromStacker]="orderTrackingModalStatus"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (refreshMainGrid)="
        getOrderTrackingDataAgainstSaleOrder(saleOrderId, projId)
      "
      (getOrderNotesEvent)="getSalesOrderNotes()"
      [salesOrderStatusD365]="salesOrderStatusD365"
      (closeModalEvent)="closeModalForOrderTracking()"></jni-order-tracking>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="showProFormalDialog"
  [displayModal]="showProFormalDialog"
  (closeEvent)="closeModalForProReport()">
  <h1 class="panelHeading">{{ showProFormalDialogHeading }}</h1>
  <div class="panelBody">
    <jni-order-summary-line-items-report
      [salesOrderLine]="salesOrderLineReport"
      [OrderLineId]="saleOrderId"
      [foreignCurrency]="foreignCurrency"
      [currencyConversion]="currencyConversion"
      [salesOrderId]="saleOrderId"
      [reportType]="reportType"
      [serviceFeeFromD365]="serviceFeeFromD365"
      (closeModalEvent)="closeModalForProReport()"
      [showProFormalDialogHeading]="showProFormalDialogHeading">
    </jni-order-summary-line-items-report>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="showWorkflowDialog"
  [displayModal]="showWorkflowDialog"
  (closeEvent)="closeWorkflowModal()">
  <div class="panelBody">
    <jni-production-workflow-summary
      *ngIf="projectWorkflowId !== 0 && workflowAssigned"
      [salesOrderId]="saleOrderId"
      [fromOrderSummary]="fromOrderSummary"
      [workflowId]="projectWorkflowId"
      (hasUnsavedChangesEvent)="onInputChange($event)"
      (closeModalEvent)="closeWorkflowModal()">
    </jni-production-workflow-summary>
    <jni-production-workflow-summary
      *ngIf="projectWorkflowId === 0 && !workflowAssigned"
      [salesOrderId]="saleOrderId"
      [fromOrderSummary]="fromOrderSummary"
      (hasUnsavedChangesEvent)="onInputChange($event)"
      (closeModalEvent)="closeWorkflowModal()">
    </jni-production-workflow-summary>
  </div>
</jni-modal-stacker>

<p-dialog
  header="Add to Project"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showProjectAssignDailog"
  [style]="{
    width: '400px',
    height: '300px',
    'border-radius': '10px',
    overflow: 'visible',
  }"
  [autoZIndex]="true"
  appendTo="body">
  <div class="p-fluid p-dir-col p-p-3">
    <p>Add to a existing Project</p>
    <div class="form-group has-float-label mb-3 mt-4">
      <label>Project Number and Name</label>
      <p-select
        [(ngModel)]="paddedProjectWorkflowId"
        [options]="preSalesProjectList"
        appendTo="body"
        (onChange)="onChangeProjectWorkflowSelection($event)"
        [showClear]="true"
        [filter]="true"
        optionValue="projectId">
        <ng-template let-project #item>
          {{ project.paddedProjectId }}
          <span *ngIf="project.customerIdD365">
            - {{ project.customerName }} - {{ project.jobName }}
          </span>
        </ng-template>
        <ng-template let-project #selectedItem>
          {{ project?.paddedProjectId }}
          <span *ngIf="project?.customerIdD365">
            - {{ project?.customerName }} - {{ project?.jobName }}
          </span>
        </ng-template>
      </p-select>
    </div>
    <div
      class="d-flex py-3 gap-2 has-sticky justify-content-end p-0 align-items-center">
      <!-- <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeProjectAssignModal()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        type="click"
        [disabled]="projectWorkflowId === 0"
        (click)="confirmAssignProjectToOrder()">
        Apply
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeProjectAssignModal()"
        variant="outlined"
        severity="secondary" />

      <p-button
        label="Apply"
        [disabled]="projectWorkflowId === 0"
        (click)="confirmAssignProjectToOrder()" />
    </div>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="modalOpen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [autoZIndex]="true"
  header="Copy Order To"
  appendTo="body">
  <div class="d-flex justify-content-between align-items-center gap-2">
    <p-button label="Order" (click)="copyCurrentHeader()" />

    <p-button label="Proposal" (click)="copyCurrentHeaderQuote()" />
  </div>
  <ng-template pTemplate="footer"> </ng-template>
</p-dialog>

<jni-modal-stacker
  *ngIf="showFreightEstimationModule"
  [displayModal]="showFreightEstimationModule"
  (closeEvent)="closeFreightEstimationModule()">
  <div class="panelBody">
    <jni-freight-quotation-detail
      [saleOrderId]="saleOrderId"
      [accountNumber]="customerAccountNumber"
      [partyNumber]="partyNumber"
      [jobName]="jobName"
      [selectedLineItems]="selectedLineItems"
      (closeModalEvent)="closeFreightEstimationModule()">
    </jni-freight-quotation-detail>
  </div>
</jni-modal-stacker>
